import { useState } from 'react'
import { hardReset } from '@/lib/appRefresh'

export function LandingPage() {
  const [isClearing, setIsClearing] = useState(false)

  const handleClearCache = async () => {
    if (isClearing) return
    setIsClearing(true)

    try {
      await hardReset()
    } catch (error) {
      console.error('❌ LandingPage: failed to clear cache:', error)
      setIsClearing(false)
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-lg shadow-xl p-8 text-center">
        <div className="mb-8">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
            style={{ backgroundColor: '#FFC107' }} // акцент вместо синего
          >
            <svg className="w-8 h-8" fill="none" stroke="#212121" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ color: '#212121' }}>
            Ассистент LEVITA
          </h1>
          <p className="" style={{ color: '#616161' }}>
            Система учёта результатов франчайзи
          </p>
        </div>

        <div className="space-y-6">
          <div
            className="rounded-lg p-4 border"
            style={{ backgroundColor: '#FFF8E1', borderColor: '#FFECB3' }} // тёплый акцент вместо синего
          >
            <div className="flex items-center justify-center mb-3">
              <svg className="w-6 h-6 mr-2" fill="none" stroke="#212121" viewBox="0 0 24 24">
                <path d="M6 10a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2v-6a2 2 0 00-2-2H6z" strokeWidth={2} />
                <path d="M8 10V8a4 4 0 118 0v2" strokeWidth={2} strokeLinecap="round" />
              </svg>
              <h2 className="text-lg font-semibold" style={{ color: '#212121' }}>
                Доступ по приглашению
              </h2>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: '#616161' }}>
              Для доступа обратитесь к своему руководителю — он отправит персональную ссылку-приглашение.
            </p>
          </div>

          <div className="space-y-3 text-left">
            <h3 className="text-sm font-medium text-left" style={{ color: '#212121' }}>
              Что вас ждёт:
            </h3>
            <ul className="text-sm space-y-2 text-left" style={{ color: '#616161' }}>
              <li className="flex items-start text-left">
                <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="#4CAF50" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Просмотр результатов работы
              </li>
              <li className="flex items-start text-left">
                <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="#4CAF50" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Аналитика и ежедневные показатели
              </li>
              <li className="flex items-start text-left">
                <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="#4CAF50" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                История операций
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 text-xs" style={{ color: '#9E9E9E' }}>
          <button
            onClick={handleClearCache}
            disabled={isClearing}
            className="mb-4 px-4 py-2 rounded text-sm font-medium transition-colors disabled:opacity-50"
            style={{
              backgroundColor: '#E0E0E0',
              color: '#212121',
              cursor: isClearing ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => !isClearing && (e.currentTarget.style.backgroundColor = '#BDBDBD')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#E0E0E0')}
          >
            {isClearing ? '⏳ Обновляем...' : '🗑️ Сбросить кэш'}
          </button>
          <p>© 2026 LEVITA</p>
          <p className="mt-1">Безопасный доступ через Telegram</p>
        </div>
      </div>
    </div>
  )
}
